import { useRef, useState, useEffect } from "react";
import "./Custom.css";
import custom1 from "../assets/custom1.png";
import custom2 from "../assets/custom2.png";
import custom3 from "../assets/custom3.png";
import custom4 from "../assets/custom4.png";
import custom5 from "../assets/custom5.png";
import { useNavigate } from "react-router-dom";

const customCards = [
  {
    id: 1,
    title: "Custom Machine Learning Model Development",
    description:
      "We build ML models that solve real operational challenges—improving accuracy, automating decisions, reducing manual work, and giving your business the intelligence it needs to scale with confidence.",
    image: custom1,
  },
  {
    id: 2,
    title: "AI Automation for Business Operations",
    description:
      "From workflow automation to intelligent process optimization, we create AI systems that eliminate repetitive tasks, reduce turnaround time, and help teams focus on high-value work instead of routine manual activities.",
    image: custom2,
  },
  {
    id: 3,
    title: "Natural Language Processing (NLP) Solutions",
    description:
      "We develop NLP models that improve customer support, automate text-heavy processes, enhance chatbot accuracy, and extract insights from massive data—making communication faster, smarter, and more efficient.",
    image: custom3,
  },
  {
    id: 4,
    title: "Computer Vision for Real-Time Insights",
    description:
      "Our computer vision solutions help businesses detect anomalies, monitor quality, analyze visual data, and automate inspections—cutting errors, enhancing safety, and improving decision-making using image and video intelligence.",
    image: custom4,
  },
  {
    id: 5,
    title: "Predictive Analytics & Forecast Intelligence",
    description:
      "We build forecasting systems that help businesses anticipate demand, reduce risks, optimize inventory, and understand customer behavior—giving decision-makers the clarity they need to stay ahead of market changes.",
    image: custom5,
  },
];

export default function Custom() {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const navigate = useNavigate();

 const checkScroll = () => {
  if (scrollContainerRef.current) {
    const { scrollLeft, scrollWidth, clientWidth } =
      scrollContainerRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);

    const cardWidth = getCardScrollWidth();
    if (cardWidth > 0) {
      setActiveIndex(Math.round(scrollLeft / cardWidth));
    }
  }
};

  useEffect(() => {
    checkScroll();
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      return () => {
        container.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 450;
      const newScrollLeft =
        direction === "left"
          ? scrollContainerRef.current.scrollLeft - scrollAmount
          : scrollContainerRef.current.scrollLeft + scrollAmount;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });
    }
  };

  const getCardScrollWidth = () => {
    if (!scrollContainerRef.current) return 0;
    const card = scrollContainerRef.current.querySelector(".card");
    if (!card) return 0;

    const gap = 24;
    return card.offsetWidth + gap;
  };

  return (
    <div id="custom">
      <div className="top">
        <div className="left">
          <h2 className="heading">
            Everything You Need in AI and Machine Learning—Under One Roof
          </h2>
          <p className="subheading">
           As a trusted machine learning development company, we deliver practical AI and ML solutions that solve real business problems, cut costs, and accelerate smarter decision-making.
          </p>
        </div>

        <div className="right">
          <button onClick={()=> navigate("/contact_us")}>Get in touch</button>
        </div>
      </div>

      <div className="slider-wrapper">
        {canScrollLeft && (
          <button
            onClick={() => scroll("left")}
            className="scroll-button scroll-button-left"
          >
            ←
          </button>
        )}

        <div
          ref={scrollContainerRef}
          className={`cards-container ${!canScrollLeft ? "padding-left" : ""} ${
            !canScrollRight ? "padding-right" : ""
          }`}
        >
          {customCards.map((card) => (
            <div key={card.id} className="card">
              <div className="card-left">
                <h2 className="card-title">{card.title}</h2>
                <p className="card-description">{card.description}</p>
              </div>

              <div className="card-right">
                <img src={card.image} alt={card.title} className="card-image" />
              </div>
            </div>
          ))}
        </div>

        {canScrollRight && (
          <button
            onClick={() => scroll("right")}
            className="scroll-button scroll-button-right"
          >
            →
          </button>
        )}
      </div>
   <div className="custom-dots">
  {customCards.map((_, index) => (
    <button
      key={index}
      className={`dot ${index === activeIndex ? "active" : ""}`}
      onClick={() => {
        scrollContainerRef.current?.scrollTo({
          left: index * getCardScrollWidth(),
          behavior: "smooth",
        });
      }}
    />
  ))}
</div>
    </div>
  );
}
